import React from 'react'

import cogniLogo from '../../images/cogni_logo.png'
import ForgotImg from '../../images/forgot_password.png'
import './forgot.css'
import { ErrorCross } from '../common/icons'

import axios from 'axios'
import { ForgotEmailSuccess } from './forgotmailSuccess'
import { Loader } from '../common/loader/loader'
import {
    EmailICon,
    ErrorIcon,
    PasswordIcons,
} from '../direct_signup/signup-page-icons'
import {
    CancelButton,
    DropdownWrapper,
    ErrorMessage,
    Input,
    InputContainer,
    InputErrorIcon,
    InputWrapper,
    InputContent,
} from '../direct_signup/signup-styled-components'

const EmailRegex = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export function ForgotPassword(props) {
    const [email, setEmail] = React.useState({
        email: '',
        error: false,
        errMsg: '',
        loading: false,
    })
    const [
        showForgotPasswordSuccess,
        setShowForgotPasswordSuccess,
    ] = React.useState(false)

    const [loading, setLoading] = React.useState(false)

    const getVerificationLink = async email =>
        (await axios.post(
            `${process.env.REACT_APP_PASSWORD_RESET_VERIFICATION_URL}`,
            {
                email: email,
            }
        )).data

    const submit = async e => {
        e.preventDefault()
        setLoading(true)
        const response = await getVerificationLink(email.email).catch(err => {
            setLoading(false)
            setEmail({
                ...email,
                error: true,
                errMsg: err.response.data.message,
                loading: false,
            })
        })
        if (response) {
            setShowForgotPasswordSuccess(true)
            setLoading(false)
        }
    }

    React.useEffect(() => {
        if (email.email.length > 0 && !EmailRegex.test(email.email)) {
            setEmail({
                ...email,
                error: true,
                errMsg: 'Please enter valid email',
            })
        }
    }, [email.email])

    return !showForgotPasswordSuccess ? (
        <Wrapper>
            {loading ? (
                <Loader.PopupLoader show={true} className="forget_password" />
            ) : (
                <React.Fragment>
                    <form className="w-100 float-left d-flex flex-column" onSubmit={submit}>
                        <h2 className="justify-content-start d-flex">Forgot password</h2>
                        <Content
                            email={email}
                            setEmail={email => {
                                setEmail({ ...email, email: email })
                            }}
                        />
                        <div className="d-flex justify-content-between">
                            <SubmitButton
                                submit={submit}
                                disabled={
                                    email.email.length === 0 ||
                                    !EmailRegex.test(email.email)
                                }
                            />
                            <BottomBar {...props} />
                        </div>
                    </form>
                </React.Fragment>
            )}
        </Wrapper>
    ) : (
        <ForgotEmailSuccess email={email.email} />
    )
}

function Wrapper(props) {
    return (
        <div className="forgot_link_login_bg_height">
            <div className="forgot_link_login_bg_width">
                <h2>
                    <span>Forgot your password?</span>
                </h2>
                <p>
                    {' '}
                    Enter your email address to request a password reset link.
                </p>
                <div className="row">
                    <div className="col-md-12 col-lg-12 forgot_link_login_bg_width_left">
                        {props.children}
                    </div>
                </div>
            </div>
        </div>
    )
}

function Content(props) {
    const { setEmail, email } = props

    return (
        <React.Fragment>
            <DropdownWrapper>
                <InputContainer>
                    <InputWrapper>
                        <Input
                            primary
                            autoFocus
                            type="text"
                            id="text"
                            onChange={e => {
                                e.preventDefault()
                                setEmail(e.target.value)
                            }}
                        />
                        <InputContent primary>Login Email</InputContent>
                        <CancelButton>
                            <EmailICon />
                        </CancelButton>

                        <>
                            {email.error && (
                                <>
                                    <InputErrorIcon style={{ right: 18 }}>
                                        <ErrorIcon />
                                    </InputErrorIcon>
                                    <ErrorMessage>{email.errMsg}</ErrorMessage>
                                </>
                            )}
                        </>
                    </InputWrapper>
                    <span
                        className={
                            !email.error
                                ? 'form-group existing_worksapce_width'
                                : 'form-group_error form-group existing_worksapce_width'
                        }
                    >
                        {' '}
                        {email.error ? (
                            <ErrorCross onClick={() => setEmail('')} />
                        ) : null}
                    </span>
                </InputContainer>
            </DropdownWrapper>
            {/* <div
                className={
                    !email.error
                        ? 'form-group existing_worksapce_width'
                        : 'form-group_error form-group existing_worksapce_width'
                }
            >
                <label for="text">Email Address</label>
                {email.error && <span>{email.errMsg}</span>}
                <input
                    autoFocus
                    type="text"
                    className="form-control"
                    id="text"
                    placeholder="Enter your email id..."
                    onChange={(e) => {
                        e.preventDefault()
                        setEmail(e.target.value)
                    }}
                />
               
            </div> */}
        </React.Fragment>
    )
}

function SubmitButton(props) {
    return (
        <button
            className="workspace_button btn btn-primary"
            type="submit"
            disabled={props.disabled}
        >
            Send Link
        </button>
    )
}

function BottomBar(props) {
    return (
        <h6>
            Back to{' '}
            <span
                onClick={() =>
                    props.history.push(process.env.REACT_APP_UI_BASE_URL)
                }
            >
                Log In
            </span>
        </h6>
    )
}
